/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { LENTE_OPTIONS } from './commandCenterConstants';

const LenteSegment = ({ value, onChange, disabled }) => (
  <ToggleButtonGroup
    exclusive
    size="small"
    value={value}
    onChange={(_, next) => {
      if (next) onChange(next);
    }}
    disabled={disabled}
    aria-label="Lente do command center"
    sx={{ flexWrap: 'wrap' }}
  >
    {LENTE_OPTIONS.map((lente) => (
      <ToggleButton key={lente.id} value={lente.id} sx={{ px: 2 }}>
        {lente.label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);

LenteSegment.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

LenteSegment.defaultProps = {
  disabled: false,
};

export default LenteSegment;
